import React from "react";
import { Link } from "react-router-dom";

const Sitemap = () => {
  const routes = [
    { path: "/", name: "Home" },
    { path: "/uberUns", name: "Über Uns" },
    { path: "/kontakt", name: "Kontakt" },
    { path: "/aktuelles", name: "Aktuelles" },
    { path: "/impressum", name: "Impressum" },
    { path: "/datenschutz", name: "Datenschutzerklärung" },
    { path: "/bildung", name: "Bildung" },
    { path: "/dialog", name: "Dialog" },
    { path: "/migration", name: "Migration" },
    { path: "/jugend", name: "Jugend & Soziales" },
    //{ path: "/demokratie", name: "Demokratie Wahl" },
    { path: "/bilderVonHeimat", name: "Bilder Von Heimat" },
    { path: "/engagementHarmonie", name: "Engagement Harmonie" },
    { path: "/anschubfoerderung", name: "Anschubfoerderung" },
    { path: "/projekt/:id", name: "Projekt Detail" },
    { path: "/detail/:categoryId", name: "All Info Details" },
  ];

  return (
    <div className="container my-5">
      <h1 className="text-center mb-4">Sitemap</h1>
      <ul className="list-group">
        {routes.map((route, index) => (
          <li key={index} className="list-group-item">
            <Link to={route.path} className="text-decoration-none text-primary">
              {route.name}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Sitemap;
